"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _useConfig = _interopRequireDefault(require("../../../../hooks/useConfig"));
var _MaacBusinessSolutionCardBody = _interopRequireDefault(require("./MaacBusinessSolutionCardBody"));
var _MaacBusinessSolutionCardHeader = _interopRequireDefault(require("./MaacBusinessSolutionCardHeader"));
var _services = require("../../../../services");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const MaacBusinessSolutionCard = _ref => {
  let {
    businessSolution
  } = _ref;
  const recommendationCharacteristics = (0, _useConfig.default)('recommendationCharacteristics', []);
  const BusinessSolutionParser = new _services.Services.Parsers.BusinessSolutionCardParser(businessSolution, recommendationCharacteristics);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_MaacBusinessSolutionCardHeader.default, BusinessSolutionParser.EntelCardHeaderProps), /*#__PURE__*/_react.default.createElement(_MaacBusinessSolutionCardBody.default, BusinessSolutionParser.EntelCardBodyProps));
};
var _default = MaacBusinessSolutionCard;
exports.default = _default;